export const HOME_PATH = "/";

export const COMPANY_INFORMATION_PATH = "company-information";

export const COMPANY_DETAILS_PATH = "company-details";

export const CONTACT_INFORMATION_PATH = "contact-information";

export const FINAL_DETAILS_PATH = "final-details";

export const THANK_YOU_PATH = "thank-you";

export const ADD_CONTACT_PERSON_PATH = "add-contact-person";

export const VERSION_PATH = "version";
